module.exports = __webpack_public_path__ + "static/mo20-40d414548ee2d82e5368d1b6310c8ce3.png";